export const fakeInstitutions = [
  {
    id: "13aa99b9-6aed-48aa-b392-afdccd0e50b8",
    name: "Acadia University",
    external_id: "31",
    province_state: "",
    country: "CA",
  },
  {
    id: "t54a99b9-6aed-48aa-b392-afdccd0e50b7",
    name: "University of Victoria",
    external_id: "32",
    province_state: "",
    country: "CA",
  },
  {
    id: "6h8a99b9-6aed-48aa-b392-afdccd0e50b6",
    name: "UBC",
    external_id: "33",
    province_state: "",
    country: "CA",
  },
  {
    id: "rrra99b9-6aed-48aa-b392-afdccd0e50b5",
    name: "Montreal School of Jazz",
    external_id: "34",
    province_state: "",
    country: "CA",
  },
];
